import VideoCard from './videoCard.component';

export * from './videoCard.types';
export default VideoCard;
